<!-- GENERATE dialog body -->
<app-reactive-form-builder
  [form]="form?.formFields!"
  [dropdownLoadTrigger]="dropdownLoadTrigger"
  (formChanges)="formChanges($event[0], $event[1])">
</app-reactive-form-builder>

@if (form?.sectores?.selected && !form?.sectores?.selected?.tiene_datos) {
  <p class="text-center mt-2" style="color: red">Este sector no tiene parcelas</p>
}

<div class="d-flex justify-content-center gap-2 mt-3">
  <button type="button" class="btn btn-dark" (click)="hideDialog.emit()">Cerrar</button>

  @if (env.appName !== 'donjardin') {
    <button type="button" class="btn btn-primary" (click)="generarCuaderno()">
      Generar Word
    </button>
  }

  @if (env.showFincasInformeTratamientos || (env.user?.nombre === 'ALEJANDRO' && env.appName === 'melia')) {
    <button type="button" class="btn btn-secondary" (click)="generarCuaderno(true, false)">
      {{ env.showTareasMto ? 'Generar' : 'Informe Tratamientos' }}
    </button>
  }

  @if (env.showFincasLibroFertilizantes) {
    <button type="button" class="btn btn-secondary" (click)="generarCuaderno(false, true)">
      Generar Libro Fertilizantes
    </button>
  }
</div>
